import type { DatovkaApiType } from '@gov-nx/api';
import type { FormDefinition2 } from '@gov-nx/core/service';
import { useFormBuilderWithConsent } from '@gov-nx/core/service';
import { usePpdfSouhlasyLocale } from '@gov-nx/module/page';
import type { DataBoxFormData } from '@gov-nx/ui/types';
import type { DataBoxFields } from '@gov-nx/utils/common';
import { useDataboxDefinition } from '@gov-nx/utils/common';

export interface PpdfSouhlasyUdeleniStep3 extends DataBoxFormData {}

export type PpdfSouhlasyUdeleniFormStep3 = FormDefinition2<
	DataBoxFormData,
	DataBoxFields
>;

export const useFormStep3 = ({
	isDisabled,
	fixedDataBoxId,
	databoxTypes,
	isLowAuthorization,
}: {
	isLowAuthorization: boolean;
	isDisabled: boolean;
	fixedDataBoxId: string;
	databoxTypes: DatovkaApiType['typSchranky'][];
}) => {
	const { t } = usePpdfSouhlasyLocale();

	const databox = useDataboxDefinition({
		name: 'datovaSchrankaId',
		label: t('formular.datova-schranka.label'),
		isDisabled,
		fixedDataBoxId: fixedDataBoxId,
		types: databoxTypes,
	});

	return useFormBuilderWithConsent<PpdfSouhlasyUdeleniStep3, DataBoxFields>(
		[...databox],
		{
			isLowAuthorization,
			isDisabled,
		}
	);
};
